export const workspace = {
  routes: [
    {
      path: "/workspace/library/abroad-third-party",
      component: () => import("../workspace-library-abroad-third-party-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/abroad-third-party",
      component: () => import("../management-library-abroad-third-party-view"),
    },
  ],
};
